import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ClubsComponent} from './clubs/app.component';
import {OrdersComponent} from './orders/app.component';
import {AccountComponent} from './app.component';
import {MaterialModule} from '../../../material.module';
import {MatDialogRef} from '@angular/material/dialog';
import {NotificationsModalComponent} from './modals/notifications/app.component';
import {PasswordModalComponent} from './modals/password/app.component';
import {DetailsModalComponent} from './modals/details/app.component';
import {AddressModule} from './address/module';
import {AddressService} from '../../services/address.service';
import {TicketComponent} from './orders/tickets/app.component';
import {ProductComponent} from './orders/products/app.component';
import {DeleteAccountConfirmComponent} from './modals/delete-account-confirm/app.component';
import {FavouritesComponent} from './favourites/app.component';
import { ProductListComponent } from '../shared/product/product-list/app.component';
import { SharedModule } from '../shared/module';
import { FavouritesService } from '../../services/favourites.service';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    AddressModule,
    SharedModule
  ],
  declarations: [
    AccountComponent,
    ClubsComponent,
    OrdersComponent,
    FavouritesComponent,
    NotificationsModalComponent,
    DetailsModalComponent,
    PasswordModalComponent,
    TicketComponent,
    ProductComponent,
    DeleteAccountConfirmComponent,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    AddressService,
    FavouritesService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountModule {}
